import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  HERO_SLIDER,
  FETCH_FRONT_MENU,
  FETCH_PARENT_CATEGORIES,
  FETCH_BRANDS,
  FETCH_HIGHLIGHTS,
  MOST_POPULAR,
  FETCH_CATEGORY_TREE,
  FETCH_CATEGORY_FILTERS,
  FETCH_DAILY_DEALS,
  FETCH_COUPON_DETAILS,
} from 'store/actionTypes';
import {
  getHeroSliders,
  getFrontMenus,
  getParentCategories,
  getBrands,
  getHighlights,
  getMostPopularItems,
  getCategoryTree,
  getCategoryFilters,
  getDealsOfTheDay,
  getCouponDetails,
} from 'services';

import {
  fetchHeroSliderSuccess,
  fetchHeroSliderError,
  fetchFrontMenuSuccess,
  fetchFrontMenuError,
  fetchParentCategoriesSuccess,
  fetchParentCategoriesError,
  fetchBrandsSuccess,
  fetchHighlightsSuccess,
  fetchHighlightsError,
  mostPopularSuccess,
  mostPopularError,
  fetchCategoryTreeSuccess,
  fetchCategoryTreeError,
  fetchCategoryFiltersSuccess,
  fetchCategoryFiltersError,
  fetchDailyDealsSuccess,
  fetchDailyDealsError,
  fetchCouponDetailsSuccess,
  fetchCouponDetailsError,
} from 'store/actions';

function* getHeroSlider() {
  try {
    const response = yield call(getHeroSliders);
    if (!response.error) {
      yield put(fetchHeroSliderSuccess(response.data));
    } else {
      yield put(fetchHeroSliderError(response.message));
    }
  } catch (error) {
    yield put(fetchHeroSliderError(error));
  }
}

export function* watchFetchHeroSlider() {
  yield takeLatest(HERO_SLIDER, getHeroSlider);
}

function* getFrontMenuItems() {
  try {
    const response = yield call(getFrontMenus);
    if (!response.error) {
      yield put(fetchFrontMenuSuccess(response.data));
    } else {
      yield put(fetchFrontMenuError(response.message));
    }
  } catch (error) {
    yield put(fetchFrontMenuError(error));
  }
}

export function* watchFetchFrontMenus() {
  yield takeLatest(FETCH_FRONT_MENU, getFrontMenuItems);
}

function* getCategories() {
  try {
    const response = yield call(getParentCategories);
    if (!response.error) {
      yield put(fetchParentCategoriesSuccess(response.data));
    } else {
      yield put(fetchParentCategoriesError(response.message));
    }
  } catch (error) {
    yield put(fetchParentCategoriesError(error));
  }
}

export function* watchFetchCategories() {
  yield takeLatest(FETCH_PARENT_CATEGORIES, getCategories);
}

function* getBrandItems() {
  try {
    const response = yield call(getBrands);
    if (!response.error) {
      yield put(fetchBrandsSuccess(response.data));
    } else {
      yield put(fetchBrandsSuccess(response.message));
    }
  } catch (error) {
    yield put(fetchBrandsSuccess(error));
  }
}

export function* watchFetchBrands() {
  yield takeLatest(FETCH_BRANDS, getBrandItems);
}

function* getHighlightItems() {
  try {
    const response = yield call(getHighlights);
    if (!response.error) {
      yield put(fetchHighlightsSuccess(response.data));
    } else {
      yield put(fetchHighlightsError(response.message));
    }
  } catch (error) {
    yield put(fetchHighlightsError(error));
  }
}

export function* watchFetchHighlights() {
  yield takeLatest(FETCH_HIGHLIGHTS, getHighlightItems);
}

function* getMostPopular() {
  try {
    const response = yield call(getMostPopularItems);
    if (!response.message) {
      yield put(mostPopularSuccess(response.data));
    } else {
      yield put(mostPopularError(response.message));
    }
  } catch (error) {
    yield put(fetchHighlightsError(error));
  }
}

export function* watchMostPopular() {
  yield takeLatest(MOST_POPULAR, getMostPopular);
}

function* getCategoryTreeItems() {
  try {
    const response = yield call(getCategoryTree);
    if (!response.error) {
      yield put(fetchCategoryTreeSuccess(response.data));
    } else {
      yield put(fetchCategoryTreeError(response.message));
    }
  } catch (error) {
    yield put(fetchCategoryTreeError(error));
  }
}

export function* watchFetchCategoryTree() {
  yield takeLatest(FETCH_CATEGORY_TREE, getCategoryTreeItems);
}

function* getCategoryFilterItems({ payload }) {
  try {
    const response = yield call(getCategoryFilters, payload);
    if (!response.error) {
      yield put(fetchCategoryFiltersSuccess(response.data));
    } else {
      yield put(fetchCategoryFiltersError(response.message));
    }
  } catch (error) {
    yield put(fetchCategoryFiltersError(error));
  }
}

export function* watchFetchCategoryFilters() {
  yield takeLatest(FETCH_CATEGORY_FILTERS, getCategoryFilterItems);
}

function* getDailyDealItems() {
  try {
    const response = yield call(getDealsOfTheDay);
    if (!response.error) {
      yield put(fetchDailyDealsSuccess(response.data));
    } else {
      yield put(fetchDailyDealsError(response.message));
    }
  } catch (error) {
    yield put(fetchDailyDealsError(error));
  }
}

export function* watchFetchDailyDeals() {
  yield takeLatest(FETCH_DAILY_DEALS, getDailyDealItems);
}

function* getCouponData() {
  try {
    const response = yield call(getCouponDetails);
    if (!response.error) {
      yield put(fetchCouponDetailsSuccess(response.data));
    } else {
      yield put(fetchCouponDetailsError(response.message));
    }
  } catch (error) {
    yield put(fetchCouponDetailsError(error));
  }
}

export function* watchFetchCouponDetails() {
  yield takeLatest(FETCH_COUPON_DETAILS, getCouponData);
}

export default function* rootSaga() {
  yield all([
    fork(watchFetchHeroSlider),
    fork(watchFetchFrontMenus),
    fork(watchFetchCategories),
    fork(watchFetchBrands),
    fork(watchFetchHighlights),
    fork(watchMostPopular),
    fork(watchFetchCategoryTree),
    fork(watchFetchCategoryFilters),
    fork(watchFetchDailyDeals),
    fork(watchFetchCouponDetails),
  ]);
}
